import React from 'react';
import {
  PageContent,
  FormGroup,
  Grid,
  Flex,
  useUserinfo,
  Loading,
  openNotificationWithIcon,
} from '@mss/mss-component-library';
import { Formik } from 'formik';
import Form from 'formik-antd/lib/form';
import { Input } from 'formik-antd/lib/input';
import SubmitButton from '../../../../common/SubmitButton';
import Api from '../../../services/Api';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { AuthorizationGroup } from 'jsx/@types/authorization';
import { useQueryClient } from '@tanstack/react-query';
type SettingsProps = {
  group: AuthorizationGroup;
  superAdminGroup: boolean;
  fetchGroup: () => void;
};

function Settings({ group, superAdminGroup, fetchGroup }: SettingsProps) {
  const [hasPermission] = useUserinfo();
  const [t] = useTranslation(['authorization', 'common']);
  const queryClient = useQueryClient();

  return (
    <PageContent title={t('Settings')}>
      {group.id === 0 && <Loading />}
      {group.id !== 0 && (
        <Formik
          onSubmit={async values => {
            try {
              const resp = await Api.group.update({
                ...group,
                name: values.name,
              });
              if (resp.ok) {
                openNotificationWithIcon(
                  notification.success,
                  t(`Group updated`),
                  `The group has been successfully renamed to ${values.name}.`
                );
                fetchGroup();
                await queryClient.invalidateQueries({
                  queryKey: ['groups'],
                });
              } else {
                throw new Error();
              }
            } catch {
              openNotificationWithIcon(
                notification.error,
                t(`Group update failed`),
                t(
                  `Due to technical issues, the group have not been updated successfully.`
                )
              );
            }
          }}
          initialValues={{ name: group.name }}
        >
          {({ values, handleBlur, handleChange }) => {
            const isDirty = group.name !== values.name;
            const mayUpdate = hasPermission('change_group') && !superAdminGroup;
            return (
              <Form>
                <Grid.Row>
                  <Grid.Col width={4}>
                    <FormGroup
                      label={t('Name')}
                      input={
                        <>
                          {mayUpdate ? (
                            <Input
                              name={'name'}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.name}
                            />
                          ) : (
                            <>{values.name}</>
                          )}
                        </>
                      }
                    />
                  </Grid.Col>
                </Grid.Row>

                {mayUpdate && (
                  <Flex h="end" v="center" style={{ marginTop: '1rem' }}>
                    <SubmitButton disabled={!isDirty} name="assetSettings">
                      {t('Save group')}
                    </SubmitButton>
                  </Flex>
                )}
              </Form>
            );
          }}
        </Formik>
      )}
    </PageContent>
  );
}

export default Settings;
